import { render, staticRenderFns } from "./Junior.vue?vue&type=template&id=5a2bd50c&"
import script from "./Junior.vue?vue&type=script&lang=js&"
export * from "./Junior.vue?vue&type=script&lang=js&"
import style0 from "./Junior.vue?vue&type=style&index=0&id=5a2bd50c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports